import React from 'react';
import { OFFER_ANCHOR, PRODUCT_IMAGE } from '../data/content';
interface ProductShotProps {
  /** Defaults to the purchase section. */
  href?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}
const sizes: Record<'sm' | 'md' | 'lg', string> = {
  sm: 'max-w-[150px]',
  md: 'max-w-[210px]',
  lg: 'max-w-[280px]'
};
export function ProductShot({
  href = OFFER_ANCHOR,
  className = '',
  size = 'md'
}: ProductShotProps) {
  const isAnchor = href.startsWith('#');
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!isAnchor) return;
    const target = document.getElementById(href.slice(1));
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <a href={href} onClick={handleClick} target={isAnchor ? undefined : '_blank'} rel={isAnchor ? undefined : 'noopener noreferrer'} className={`mx-auto block ${sizes[size]} ${className}`} aria-label="SENIOR ACTIVITY READY™ — go to the offer" data-id="element-192" data-mp="l4pu2tskdlbk">
      <img src={PRODUCT_IMAGE} alt="SENIOR ACTIVITY READY™ — The Complete Activity System box set" className="h-auto w-full drop-shadow-[0_12px_24px_rgba(23,54,84,0.25)] transition-transform duration-200 ease-out hover:scale-[1.02]" data-id="element-193" data-mp="2pd05i0x9ntp6" />
    </a>;
}